import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_15195_8548" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_15195_8548)">
    <path d="M8.40351 17L7 15.5965L10.609 11.9875L7 8.40351L8.40351 7L12.0125 10.609L15.5965 7L17 8.40351L13.391 11.9875L17 15.5965L15.5965 17L12.0125 13.391L8.40351 17Z" fill="#858585"/>
  </g>
</svg>
);

export default Icon;
